
<div class="options-search-box-container">
  <div class="options-search-icon-container">
    <mat-icon class="search-icon"
              [class.clear]="!!searchInput.value"
              (click)="clearSearchValue($event)">
      {{ !!searchInput.value ? 'clear' : 'search' }}
    </mat-icon>
  </div>

  <input #searchInput [placeholder]="placeholder" (input)="handleSearchChange()" />
</div>
